export const DAILY_RENT_OTA_CONVERSION = 'dailyrent_web_sut375_online_booking_cr';

export const NEWBUILDING_MONTHLY_PAYMENT = 'newbuilding_monthly_payment_desktop';

export const EXPERIMENTS = [DAILY_RENT_OTA_CONVERSION, NEWBUILDING_MONTHLY_PAYMENT];
